import { useQuery } from "@tanstack/react-query"

import { getLiveForHireMetrics } from "@/features/logistics/api/getLiveForHireMetrics.ts"
import { numberFmt } from "@/util/numberFmt.ts"

import { getRPMLoaded } from "../../api/ForHire/getRPMLoaded.ts"
import MetricDisplay from "../MetricDisplay.tsx"
import MetricsCard from "../MetricsCard.tsx"

export default function ForHireMonthlyDisplay() {
  const { data, isPending, isError } = useQuery({
    queryKey: ["liveForHireMetrics", "Monthly"],
    queryFn: () => getLiveForHireMetrics("Monthly"),
    refetchInterval: 5000,
  })

  const rpmQuery = useQuery({
    queryKey: ["loadedRPM"],
    queryFn: getRPMLoaded,
  })

  const MMBTU_TO_DGE = 7.72
  const fuel_dge = data ? ((data.fuelConsumed * 909.4) / 1010) * MMBTU_TO_DGE : 0
  const fuel_efficiency = data && data.fuelConsumed > 0 ? data.milesDriven / fuel_dge : 0
  const revenueString =
    data && data.revenuePerUsedTruck && data.revenuePerUsedTruckStDev
      ? numberFmt(data.revenuePerUsedTruck) +
        " (" +
        numberFmt(data.revenuePerUsedTruckStDev) +
        " stdev)"
      : ""

  return (
    <MetricsCard title="Monthly Totals">
      <div className="flex justify-between gap-4">
        <MetricDisplay
          label="Revenue Total"
          value={data ? data.dailyRevenue : 0}
          loading={isPending}
          error={isError}
          unit="$"
        />
        <MetricDisplay
          label="Revenue per Active Truck"
          value={revenueString}
          loading={isPending}
          error={isError}
          unit="$"
        />
      </div>
      <MetricDisplay
        label="Revenue per Loaded Mile"
        value={rpmQuery.data || 0}
        loading={rpmQuery.isPending}
        error={rpmQuery.isError}
        currency={true}
        unit="$"
      />
      <MetricDisplay
        label="Miles Driven"
        value={data ? data.milesDriven : 0}
        loading={isPending}
        error={isError}
      />
      <MetricDisplay
        label="Fuel Consumed"
        value={data ? data.fuelConsumed : 0}
        loading={isPending}
        error={isError}
        unit="MMBtu"
      />
      <MetricDisplay
        label="Fuel Efficiency"
        value={fuel_efficiency}
        loading={isPending}
        error={isError}
        unit="Miles per DGE"
      />
    </MetricsCard>
  )
}
